const user = JSON.parse(localStorage.getItem("user_data")) || {};

const staffId = user.staffId !== undefined ? parseInt(user.staffId) : 0;

const config = {};

if (staffId > 0) {
  config.headers = {
    "Authorization": `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
    "Content-Type": "application/json",
    "staffId": staffId,
  };
} else {
  config.headers = {
    "Authorization": `Bearer 7fa5d115dbbf825a0a4abb2b2a7f37de`,
    "Content-Type": "application/json",
    "staffId": null,
  };
}
export { config };

